const Insecticides = [
    {
        _id:"1",
        name:"3RD DEGREE",
        image:"/images/Insecticides/1.png",
        Title:"(Thiamethoxam 12.6% + Lambda-cyhalothrin 9.5% ZC)",
        description: "It is a combination insecticide having quick stomach and contact activity and is recommended to control Aphids, jassids, Thrips & Bollworms in Cotton, Aphid, shootfly, steam borer in Maize, Leaf hopper, leaf eating caterpillars in Groundnut, Stem fly, semilooper, girdle beetle in Soyaben, Thrips & fruit borer in Chilli, Thrips, semilooper, tea mosquito bug in Tea, Thrips, whiteflies, fruit borer in Tomato crop."
    },
    {
        _id:"2",
        name:"ARMY",
        image:"/images/Insecticides/2.png",
        Title:"(Fipronil 0.3% GR)",
        description: "It is recommended for the control of Stem borer, Brown plant hopper, Green leafhopper, Rice leaf folder, Gall midge, White backed plant hopper, whorl maggot of Rice Early shoot borer, and Root borer of sugarcane and termites of wheat."
    },
    {
        _id:"3",
        name:"ARMY MAX",
        image:"/images/Insecticides/3.png",
        Title:"(Fipronil 18.87% SC)",
        description: "It is a phenyl pyrazole insecticide for foliar application. Its foliar application is highly effective against Thrips on cotton at very low doses. It can control insects that have developed resistance to all other classes of insecticides. Fipronil 18.87% w/w SC formulations contains 188.7 g of Fipronil active ingredient per kg of formulations which is equal to 200 g of Fipronil active ingredient per litre formulations fipronil is an insecticide used as a foliar spray for the control of thrips in cotton."
    },
    {
        _id:"4",
        name:"ARMY PLUS",
        image:"/images/Insecticides/4.png",
        Title:"ARMY PLUS (Fipronil 5% SC)",
        description: "It is a modern insecticide of Phenylpyrazole group which controls the insect pests of rice, chilli, cabbage/cauliflower and sugarcane effectively. It controls the insects by its contact, stomach and systemic action. It gives effective and long duration control of thrips in various crops."
    },
    {
        _id:"5",
        name:"BAHUBALI",
        image:"/images/Insecticides/5.png",
        Title:"(Triazophos 40% EC)",
        description: "It is contact & stomach posion. It is non-systemic, but penetrates deeply in to the plant tissues. It is recommended to control pink bollworms, spotted bollworms and white fly of cotton. stem borer, leaf folder, green leaf hopper, hispa, Brown plant hopper and White backed plant hopper of rice and griddle beetle, stem borer and leaf minor of soyabean."
    },
    {
        _id:"6",
        name:"BLACK BOMB",
        image:"/images/Insecticides/6.png",
        Title:"(Buprofenzin 15% + Acephate 35% WP)",
        description: "It is a wettable powder containing Buprofenzin 15% (a.i.) and Acephate 35% (a.i.) in the formulation. It isused for the control of Brown plant hopper and white back plant hopper in Paddy crops. The required quantity of ready mix chemical buprofenzin 15% + acephate 35% need to be diluted in water and sprayed by using hand operated knapsack sprayer with a spray volume @ 500l/ha.Buprofenzin 15% and Acephate 35% w/w ap is used for the control of brown plant hopper and white back plant hopper of paddy crop."
    },
    {
        _id:"7",
        name:"Black Gold Bupro",
        image:"/images/Insecticides/7.png",
        Title:"(Buprofenzin 25% SC)",
        description: "It is an insecticide used for the control of sucking pest of Rice, Cotton, Chillies Mango &Grapes particularly against plant hoppers, Whiteflies, Aphids, Jassids, Thrips, Mites, Hoppers, Mealy bugs etc.Preparation of spray mixture: Take the required quantity of insecticide, dilute with a little water and stir well using a stick, then add the remaining quantity of water as per spray volume required and mix well again by stirring.Plant protection equipments: Use knapsack sprayer, foot sprayer, compression knapsack sprayer, compression knapsack battery sprayer or ASPEE-HTP sprayer."
    },
    {
        _id:"8",
        name:"BOMBER",
        image:"/images/Insecticides/8.png",
        Title:"(Fipronil 40% + Imidaclorpid 40% WG)",
        description: "It is a contact and systemic insecticide. It contains 400 gram of Fipronil and 400 gram of Imidacloprid active ingredients, per kg of formulation. Fipronil 40% + Imidacloprid 40% WG is recommended for control of White grubs in Sugarcane. Warning: The product should not be used when honey bees are actively foraging."
    },
    {
        _id:"9",
        name:"Brigade",
        image:"/images/Insecticides/9.png",
        Title:"(Fipronil 80% WG)",
        description: "Fipronil 80% w/w WG formulation contains 800 g fipronil active ingredient per kg of formulation, fipronil is an insecticides used as a foliar spray for the control of stem borer and leaf folder in Rice, thrips in Grapes, thrips in Onion and Cotton.Give first spray as soon as incidence of stem borer (appearance of dead hearts) and leaf folder (appearance of white stripes on leaves) start"
    },
    {
        _id:"10",
        name:"CARBO-GP",
        image:"/images/Insecticides/10.png",
        Title:"(Carbofuran 3% CG)",
        description: "It is a broad spectrum carbamate insecticide,nematicide and miticide having systematic action. It contains 3% active ingredient carbofuran and balance other relevant ingredients. It is recommended to control shoot fly of Bajra, brown plant hopper, gall midge, green leaf hopper, hispa, stem borer & nematode of paddy, pod borer and white grub of groundnut; and top borer of sugarcane and insects of other crops"
    },
    {
        _id:"11",
        name:"CHHU-MANTAR",
        image:"/images/Insecticides/11.png",
        Title:"(Chlorpyriphos 1.5% DP)",
        description: `It is An organophosphorus dust insecticide for the control of crop pests only. If is recommended for the control of stem borer, green leaf hopper, brown plant hopper, pod borer and white grub of groundnut; and top borer of sugarcane and gall midge & grass hopper in paddy crops.`
    },
    {
        _id:"12",
        name:"FERTIX",
        image:"/images/Insecticides/12.png",
        Title:"(Imidacloprid 0.3% GR)",
        description: `It is broad spectrum insecticide having contact and stomach action. It is compatible with
        most of the commonly used pesticides except those of alkaline materials. It is a foliar
        insecticide with acaricidal properties for use in action.`
    },
    {
        _id:"13",
        name:"FOCUS 161",
        image:"/images/Insecticides/13.png",
        Title:"(Chlorpyrifos 16% + Alphacypermethrin 1% E.C)",
        description: `It is a versatile broad spectrum insecticide, It is extremely effective against all types of bollworms. It is a
        contact and stomach insecticide with vapour action and quick knock down effect. It is used to control
        bollworm pest of cotton.`
    },
    {
        _id:"14",
        name:"FULL STOP",
        image:"/images/Insecticides/14.png",
        Title:"(Alphacypermethrin 10% EC)",
        description: `It is a Recommended for control of cotton bollworms. spotted bollworms and white fly of cotton. stem
        borer, leaf folder, green leaf hopper, Application and storage recommendations: Take the required
        quantity of Alphamethrin 10 EC, dilute it with a little water and stir well. Then add the remaining
        quantities of water as per spray volume required. Stir well to form a ready-to-use spray. Use
        Knapsack sprayer fitted with fine mist nozzle.`
    },
    {
        _id:"15",
        name:"G-TOP GR",
        image:"/images/Insecticides/15.png",
        Title:"(Cartap Hydrochloride 4% GR)",
        description: `It is a granule formulation insecticide which contains 4% cartap hydrochloride a.i. and balance
        adjuvants. It is recommednded to control stem borer, leaf folder and whorl maggot of rice crop Cartap Hydrochloride has a quite different mode of action from that of other insecticides. It is effective against both chewing and sucking insects and controls at a low concentration.`
    },
    {
        _id:"16",
        name:"GPMC",
        image:"/images/Insecticides/16.png",
        Title:"(Fenobucarb (B.P.M.C) 50% EC)",
        description: `is a stomach and contact action insecticides recommended for the control of Brown Plant hopper,
        Green leaf hopper of rice. It is recommended for the control of Brown plant hopper, Green leaf hopper of rice. Fenobucarb controls almost all stages of insects and the efficacy of Fenobucarb is prolonged. It has no effect to natural enemies of insect pests and it is practically nontoxic to mammals.`
    },
    {
        _id:"17",
        name:"HELICOPTER",
        image:"/images/Insecticides/17.png",
        Title:"(Fipronil 4% + Acetamiprid 4% SC)        ",
        description: `It is a combination of a new generation Phenylpyrazole compound. Fipronil and a
        neonicotinoid, Acetamiprid which bring together excellent synergism in controlling various
        sucking pests complex in cotton crop. It kills insects through contact, ingestion, systemic action
        as well as translaminar effect. It should be applied as foliar spray for the control of aphids,
        jassids and whiteflies as soon as they appear on the cotton crop.`
    },
    {
        _id:"18",
        name:"HIGH VOLTAGE THUNDER",
        image:"/images/Insecticides/18.png",
        Title:"(Emamectin Benzoate 1.9% EC)",
        description: `It is a water soluble liquid formulation containing 1.9% active ingredient and is recommended
        for the control of bollworms in cotton. It is an insecticide with stomach action and should be
        ingested by the larvae to be most effective. Affected larvae become paralyzed and stop
        feeding shortly after exposure to Emamectin Benzoate 1.9% EC and subsequently die after 2-
        4 days.`
    },
    {
        _id:"19",
        name:"INDOXA-G",
        image:"/images/Insecticides/19.png",
        Title:"(Indoxacarb 14.5% SC)",
        description: `It is a broad spectrum contact and stomach insecticide effective as a foliar spray for the control
        of insect pests of Cotton, Tomato, Chilli, Cabbage and Pigeonpea. insecticide used for the
        control of Jassids, whiteflies & bollworms on cotton and thrips & fruit borer on chillies.`
    },
    {
        _id:"20",
        name:"INQUIRY",
        image:"/images/Insecticides/20.png",
        Title:"(Cypermethrin 25% E.C.)",
        description: `It is highly active synthetic pyrethroid insecticide based jon Cypermethrin technical. Its 25%
        w/w as its active ingredient and balance adjuvants. It is recommended to control shoot & fruit
        borer, jassids of Bhindi, Shoot & Fruit borer, Jasids, Epilachna grub of Brinjal and
        Bollowovnes, Jassids, Thrips of cotton.`
    },
    {
        _id:"21",
        name:"INQUIRY X-100",
        image:"/images/Insecticides/21.png",
        Title:"(Cypermethrin 10% + Indoxacarb 10% SC)",
        description: `It is a pre-mix suspension concentrate containing Cypermethrin a.i. @ 100 gm per lit and Indoxacarb
        a.i. @ 100 gm per lit formulation. It is recommended for the control of jassid, thrips, and bollworms in
        cotton crop. It is recommended to use Knapsack sprayer or motorized Knapsack sprayer fitted with
        high volume nozzle. Take the measured quantity of insecticide and add to it a small quantity of water,
        mix thoroughly and then add remaining quantity of water. Stir well to form a ready to use spray. Do
        not spray against the wind.`
    },
    {
        _id:"22",
        name:"JAILER",
        image:"/images/Insecticides/22.png",
        Title:"JAILER (Acetamiprid 20% SP)",
        description: `Is a world renowned insecticide of Neonicotinoid group for sucking insects It controls the sucking insects very effectively by its extraordinary systemic action. It has the ability to control the insects which gained resistance against other insecticides.`
    },
    {
        _id:"23",
        name:"JCB POWER",
        image:"/images/Insecticides/23.png",
        Title:"(Thiamethoxam 30 % FS)",
        description: `It is broad- spectrum systemic insecticide that is well suited for seed treatement used to control
        early season sucking pests. Recommended as seed treatment to control Jassids, aphids and
        Whitefly in cotton, shoot fly on sorghum and Maize, termites in wheat, jassid in okra, Thrips,
        GLH and Whorl Maggot in rice, jassid and thrips in sunflower, stem fly in soybean and thrips in
        chilli crop. Due to its fast action on sucking pest, it limits the transmission of leaf curl virus.`
    },
    {
        _id:"24",
        name:"JCB THUNDER",
        image:"/images/Insecticides/24.png",
        Title:"(Thiamethoxam 75 %SG)",
        description: `It is a broad spectrum systemic insecticide, recommended for its use to control termites in
        Groundnut, Termite It is broad- spectrum systemic insecticide that is well suited for seed
        treatement used to control early season sucking pests. Recommended as seed treatment to
        control Jassids, aphids and Whitefly in cotton, shoot fly on sorghum and Maize,aggot in rice,
        jassid and thrips in sunflower, stem fly in soybean and thrips in chilli termites in wheat, jassid
        in okra, T& Early shoot borer in sugarcane, Greenleaf hopper & brown plant hopper in rice and
        Jassids & thrips in cotton crop.`
    },
]
export default Insecticides